const convertUserSessionFromServer = (user) => (Object.assign(Object.assign({}, user), { is_active: user.is_active === "1" }));
export { convertUserSessionFromServer };
